import React from "react";
import FacultyProfilePage from "../components/FacultyProfile";
import Navbar from "../components/Navbar";

const AbhaySardesai = () => {
    return (
        <>
            <Navbar />
            <FacultyProfilePage
                name="Abhay Sardesai"
                image="/black-candy-install-2-scaled.jpg"
                profileImage="/Abhay-Sardesai-min.jpg"
                bio="Mr Abhay Sardesai has been the Editor of Art India Magazine since November 2002. Under his guidance, the magazine has developed a Culture Studies oriented approach and has become more interdisciplinary in its explorations. Mr Sardesai is an eminent academic who teaches at institutes across the country. Mr Sardesai has written widely on art and literature and read from his work at the University of Princeton, University of Cambridge, Mumbai University, S.N.D.T. University, Sarai and the NGMA."
            />
        </>
    );
};

export default AbhaySardesai;